/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesEt = {
  privacy: {
    pageTitle: "Privaatsuspoliitika",
    lastUpdated: "Viimati uuendatud: 1. juuni 2026",
    introduction: {
      title: "Sissejuhatus",
      body: "WasOK on kohalikult esmalt töötav ostuabi rakendus, mis on loodud aitama kasutajatel meeles pidada tooteid, mida nad on varem ostnud, hinnanud või üle vaadanud.\n\nSee privaatsuspoliitika selgitab, millist teavet rakenduse kasutamisel töödeldakse, kuidas andmeid säilitatakse ja kuidas teatud kolmandate osapoolte teenused võivad toimida.",
    },
    dataStored: {
      title: "Rakenduse salvestatud andmed",
      body: "WasOK salvestab teie seadmesse kohalikult järgmise teabe:\n\n• skannitud toote vöötkoodid\n• kasutaja sisestatud tootenimed ja üksikasjad\n• hinnangud ja kommentaarid\n• ostunimekirjad\n• tootekategooriad\n• hinnad ja poeandmed\n• toote- ja poefotod\n\nTeie tooteandmeid ega fotosid WasOK serveritesse ei laadita.",
    },
    permissions: {
      title: "Kasutatavad õigused",
      camera: {
        title: "Kaamera",
        body: "Kaamera juurdepääsu kasutatakse:\n\n• vöötkoodide skannimiseks\n• toodete fotode tegemiseks",
      },
      photos: {
        title: "Fotod ja meedia",
        body: "Foto- või galeriijuurdepääsu kasutatakse ainult siis, kui:\n\n• lisate toodetele pilte\n• taastate fotodega varukoopiaid",
      },
      files: {
        title: "Faili- ja salvestusruumi juurdepääs",
        body: "Failijuurdepääsu võidakse kasutada:\n\n• varukoopiafailide eksportimiseks\n• kasutaja valitud varukoopiate importimiseks\n• ostunimekirjade või varukoopiate jagamiseks",
      },
    },
    backup: {
      title: "Varundamine ja eksport",
      body: "WasOK võimaldab kasutajatel luua varukoopiafaile, mis sisaldavad rakenduse andmeid ja valikulisi fotosid.\n\nVarukoopiafailid luuakse kohalikult teie seadmes ning neid võib salvestada või jagada kasutaja valitud teenuste abil, näiteks:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• kohalik seadme salvestusruum\n\nWasOK ei laadi varukoopiaid oma serveritesse.",
      onlineProductLookup: {
        title: "Tooteotsing internetis",
        body: "Kui lubate eelistustes veebipõhise vöötkoodiotsingu, võib WasOK saata ainult skannitud vöötkoodi numbri avalikesse tooteandmebaasidesse (näiteks Open Food Facts), et soovitada tootenime ja kaubamärki. WasOK ei laadi selle funktsiooni jaoks üles teie hinnanguid, kommentaare, fotosid, ostunimekirju, kategooriaid, poeandmeid ega varukoopiaandmeid. Saate selle igal ajal eelistustes välja lülitada.",
      },
    },
    advertising: {
      title: "Reklaam ja kolmandate osapoolte teenused",
      intro:
        "WasOK kasutab teatud funktsioonide pakkumiseks valitud kolmandate osapoolte teenuseid.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob-i kasutatakse reklaamide kuvamiseks rakenduses.\n\nGoogle ja tema partnerid võivad töödelda teavet nagu:\n\n• reklaamiidentifikaatorid\n• seadme teave\n• IP-aadress\n• diagnostika- ja kasutusandmed\n\nTeatud piirkondade kasutajatelt võidakse enne isikupärastatud reklaamide kuvamist küsida nõusolekut.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK kasutab Firebase Crashlyticsit, et tuvastada krahhe ja parandada rakenduse stabiilsust.\n\nKrahhide aruanded võivad sisaldada tehnilist teavet nagu:\n\n• seadme mudel\n• operatsioonisüsteemi versioon\n• rakenduse versioon\n• krahhidiagnostika\n\nKrahhide aruanded ei sisalda tahtlikult teie tootehinnanguid, märkmeid, ostunimekirju ega fotosid.",
      },
      externalProductDatabases: {
        title: "Välised tooteandmebaasid",
        body: "Vöötkoodiotsingu funktsioon võib tooteinfo hankimiseks kasutada väliseid tooteandmebaase.\n\nLisateabe saamiseks tutvuge vastavate teenusepakkujate privaatsuspoliitikatega.",
      },
    },
    dataSecurity: {
      title: "Andmeturve",
      body: "WasOK salvestab rakenduse andmeid kohalikult teie seadmes, kasutades operatsioonisüsteemi pakutavaid salvestusmehhanisme.\n\nKuigi kohalike rakenduse andmete kaitsmiseks võetakse mõistlikke meetmeid, ei ole ükski elektroonilise salvestamise meetod täiesti turvaline.\n\nKasutajad vastutavad oluliste andmete varukoopiate hoidmise eest, kui soovivad.",
    },
    children: {
      title: "Laste privaatsus",
      body: "WasOK ei ole suunatud alla 13-aastastele lastele.",
    },
    notifications: {
      title: "Teavitused",
      body: "WasOK võib valikuliselt luua teie seadmesse kohalikke teavitusi, et meelde tuletada tooteid pärast ostu hinnata.\n\nNeed teavitused luuakse ja planeeritakse kohalikult teie seadmes ning ei vaja kontot ega kaugserverit.\n\nSaate teavitused igal ajal välja lülitada seadme seadetes või rakenduses, kui see on toetatud.",
    },
    yourControl: {
      title: "Teie kontroll andmete üle",
      body: "Saate:\n\n• salvestatud tooteid igal ajal redigeerida või kustutada\n• rakenduse andmed seadmest tühjendada\n• rakenduse desinstallida\n• oma andmete varukoopiaid eksportida",
    },
    changes: {
      title: "Muudatused selles poliitikas",
      body: "Seda privaatsuspoliitikat võidakse aeg-ajalt uuendada.\n\nMuudatused jõustuvad, kui uuendatud versioon avaldatakse.",
    },
    contact: {
      title: "Kontakt",
      body: "Kui teil on selle privaatsuspoliitika kohta küsimusi, võtke ühendust:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Teenusetingimused",
    lastUpdated: "Viimati uuendatud: 1. juuni 2026",
    acceptance: {
      title: "Tingimuste aktsepteerimine",
      body: "WasOK allalaadimise, installimise või kasutamisega nõustute nende teenusetingimustega.\n\nKui te nende tingimustega ei nõustu, ei tohiks te rakendust kasutada.",
    },
    license: {
      title: "Litsents",
      body: "WasOK annab teile piiratud, mitteainuõigusliku, mitteülekantava, tühistatava litsentsi rakenduse kasutamiseks vastavalt nendele tingimustele.",
    },
    acceptableUse: {
      title: "Lubatud kasutus",
      body: "Te nõustute mitte:\n\n• rakendust väärkasutama\n• rakenduse tööd häirima\n• proovima rakendust pöördprojekteerida või muuta\n• kasutama rakendust vastuolus kohaldatavate seaduste või määrustega",
    },
    localData: {
      title: "Kohalikud andmed ja varukoopiad",
      body: "WasOK salvestab kasutajaandmeid kohalikult seadmesse.\n\nKasutajad vastutavad oluliste andmete varukoopiate hoidmise eest, kui soovivad.\n\nKuigi varundamise ja taastamise funktsioon võib olla saadaval, ei taga WasOK kaitset salvestatud andmete kaotsimineku, riknemise või tõrke eest.",
    },
    advertisements: {
      title: "Reklaamid",
      body: "Rakendus võib kuvada kolmandate osapoolte reklaamipartnerite, sealhulgas Google AdMob-i, pakutavaid reklaame.",
    },
    noWarranty: {
      title: "Garantiid puuduvad",
      body: "WasOK on saadaval „nagu on“ ja „nagu saadaval“ ilma mis tahes liiki otseste või kaudsete garantiideta.\n\nMe ei garanteeri, et:\n\n• rakendus on alati saadaval\n• rakendus on veavaba\n• andmete kaotsiminekut kunagi ei juhtu\n• kõik funktsioonid töötavad katkestusteta kõigil seadmetel",
    },
    limitationLiability: {
      title: "Vastutuse piiramine",
      body: "Seadusega lubatud maksimaalses ulatuses ei vastuta WasOK ega selle arendajad:\n\n• andmete kaotsimineku\n• kasumi kaotuse\n• seadmeprobleemide\n• kaudsete või kaasnevate kahjude\n• katkestuste eest, mis tulenevad rakenduse kasutamisest või kasutamise võimatusest",
    },
    thirdParty: {
      title: "Kolmandate osapoolte teenused",
      body: "Teatud funktsioonid või sisu võivad sõltuda kolmandate osapoolte teenustest, sealhulgas reklaamipakkujatest ja kasutaja valitud välistest salvestus-/jagamisteenustest.\n\nWasOK ei vastuta kolmandate osapoolte teenuste ega nende poliitikate eest.",
    },
    productInformation: {
      title: "Tooteinfo",
      body: "Teatud toote üksikasjad võivad pärineda kolmandate osapoolte vöötkoodiotsingu teenustest.\n\nWasOK ei garanteeri väliste andmeallikate teabe täpsust, täielikkust, kättesaadavust ega sobivust.\n\nKasutajad peaksid vajadusel tooteinfot ise kontrollima.",
    },
    changesApp: {
      title: "Rakenduse muudatused",
      body: "WasOK-i võidakse igal ajal ilma eelneva etteteatamiseta muuta, uuendada, peatada või lõpetada.",
    },
    changesTerms: {
      title: "Nende tingimuste muudatused",
      body: "Neid tingimusi võidakse perioodiliselt uuendada.\n\nRakenduse jätkuv kasutamine pärast uuenduste jõustumist tähendab muudetud tingimustega nõustumist.",
    },
    contact: {
      title: "Kontakt",
      body: "Küsimuste korral nende tingimuste kohta võtke ühendust:\n\nsupport@wasok.app",
    },
  },
};
